/**
 * Textos dos componentes da suíte (SPEC-v2 2.2–2.4, 8.6; SPEC 9.11): pt-BR, caixa de frase, sem
 * exclamação na interface.
 */
import type { Area } from '@rota/contracts';

export const AREA_NAME: Readonly<Record<Area, string>> = {
  painel: 'Painel',
  automacoes: 'Automações',
  estudio: 'Estúdio',
  palco: 'PalcoTube',
};

export const AREA_TAGLINE: Readonly<Record<Area, string>> = {
  painel: 'Quanto entrou, de onde veio e o que fazer agora.',
  automacoes: 'Cada comentário vira uma conversa, sem cara de robô.',
  estudio: 'O que gravar, o que está pronto e o que funcionou.',
  palco: 'Suas VSLs no seu player, com cada segundo medido.',
};

export const suiteCopy = {
  areaSwitcher: {
    trigger: (name: string) => `${name}, trocar de área`,
    list: 'Áreas da Rota',
    shortcut: (n: number) => `g ${n}`,
    current: 'área atual',
  },
  launcher: {
    open: (name: string) => `Abrir ${name}`,
    continueIn: (name: string) => `Continuar no ${name}`,
    continueInF: (name: string) => `Continuar na ${name}`,
    unavailable: 'Resumo indisponível agora',
    badge: (n: number) => (n === 1 ? '1 item pede atenção' : `${n} itens pedem atenção`),
  },
  login: {
    email: 'E-mail',
    password: 'Senha',
    show: 'Mostrar senha',
    hide: 'Ocultar senha',
    capsLock: 'Caps Lock ligado',
    remember: 'Manter conectado neste aparelho',
    submit: 'Entrar',
    submitting: 'Entrando',
    retryIn: (mmss: string) => `Tente de novo em ${mmss}`,
    otherAccount: 'Outra conta',
    rememberedAs: (name: string) => `Entrar como ${name}`,
    forgot: 'Esqueci a senha',
    error: 'E-mail ou senha incorretos.',
  },
  otp: {
    label: 'Código de 6 dígitos',
    hint: 'Digite o código do app autenticador.',
  },
  stepUp: {
    title: 'Confirme que é você',
    password: 'Senha',
    totp: 'Código de 6 dígitos',
    useTotp: 'Usar o código do app autenticador',
    usePassword: 'Usar a senha',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    hint: 'Vale por 15 minutos neste aparelho.',
  },
  bell: {
    label: 'Notificações',
    labelCount: (n: number) => (n === 1 ? 'Notificações, 1 nova' : `Notificações, ${n} novas`),
    title: 'Notificações',
    markAll: 'Marcar todas como lidas',
    empty: 'Nada pedindo a sua atenção agora.',
    from: (area: string) => `De ${area}`,
  },
  limit: {
    prefix: 'Limite da Meta',
    source: 'Fonte: Meta',
    sourceAria: (text: string) => `Fonte oficial da Meta sobre: ${text}`,
  },
  countdown: {
    window24h: (left: string) => `Janela de 24 h · ${left}`,
    human7d: (left: string) => `Agente humano · ${left}`,
    sla: (left: string) => `Responder em ${left}`,
    due: (left: string) => `Vence em ${left}`,
    overdue: (late: string) => `Atrasado ${late}`,
    closed: 'Fechada',
    compactLeft: (left: string) => left,
  },
} as const;
